import styled, { css } from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  /* O portal no body precisa ficar acima do Modo Foco (9000). */
  z-index: 10000;
  pointer-events: auto;
  padding: 16px;
`;

export const Modal = styled.div`
  background: #ffffff;
  border-radius: 14px;
  padding: 22px 24px;
  width: min(440px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.22);
  overflow: hidden;
`;

export const Title = styled.h3`
  margin: 0;
  flex-shrink: 0;
  font-size: 17px;
  color: #0f172a;
`;

export const Message = styled.div`
  margin: 0;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 4px;
  font-size: 14px;
  color: #1f2933;
  line-height: 1.45;

  strong {
    color: #0f172a;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
`;

type ButtonTone = 'cancel' | 'primary' | 'danger';

export const Button = styled.button<{ $tone: ButtonTone; $busy?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 96px;
  height: 38px;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  ${({ $tone }) => {
    if ($tone === 'cancel') {
      return css`
        background: #ffffff;
        color: #1f2933;
        border-color: #d1d5db;
        &:hover:not(:disabled) {
          background: #f3f4f6;
        }
      `;
    }
    if ($tone === 'danger') {
      return css`
        background: #dc2626;
        color: #ffffff;
        border-color: #dc2626;
        &:hover:not(:disabled) {
          background: #b91c1c;
          border-color: #b91c1c;
        }
      `;
    }
    return css`
      background: #2d6a4f;
      color: #ffffff;
      border-color: #2d6a4f;
      &:hover:not(:disabled) {
        background: #1b4332;
        border-color: #1b4332;
      }
    `;
  }}
`;

export const Spinner = styled.span`
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
